/**
 * Mantiene la scelta medico/prestazione/data/ora tra login/registrazione e area paziente.
 */
const STORAGE_KEY = 'vc_booking_intent';
const INTENT_TTL_MS = 10 * 60 * 1000; // 10 minuti (PRD E3)

export function saveBookingIntent(intent) {
  if (typeof sessionStorage === 'undefined' || !intent) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...intent, savedAt: Date.now() })
    );
  } catch {
    /* quota / private mode */
  }
}

export function getBookingIntent() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.savedAt && Date.now() - parsed.savedAt > INTENT_TTL_MS) {
      clearBookingIntent();
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearBookingIntent() {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(STORAGE_KEY);
}

/**
 * Intent per prenotazione da scheda medico pubblica o area paziente.
 * @param {object} opts.idTariffa, durataMin, isVideo opzionali
 */
export function buildMedicoBookingIntent(medico, medicoSlug, selectedDate, slot, opts = {}) {
  if (!medico?.id || !medicoSlug || !selectedDate || !slot) return null;
  const path = `/app/paziente/prenota/medico/${medicoSlug}`;
  return {
    path,
    state: {
      selectedDate,
      slot,
      medicoId: medico.id,
      idTariffa: opts.idTariffa ?? null,
      durataMin: opts.durataMin ?? null,
      isVideo: opts.isVideo ?? null,
      nomePrestazione: opts.nomePrestazione ?? null,
      importo: opts.importo ?? null,
      canale: opts.canale ?? null,
      idStruttura: opts.idStruttura ?? null,
      idSede: opts.idSede ?? null,
      modalita: opts.modalita ?? null,
      pagatore: opts.pagatore ?? null,
      idFondo: opts.idFondo ?? null,
    },
  };
}

export function saveMedicoBookingIntent(medico, medicoSlug, selectedDate, slot, opts = {}) {
  const intent = buildMedicoBookingIntent(medico, medicoSlug, selectedDate, slot, opts);
  if (intent) saveBookingIntent(intent);
  return intent;
}

/** Dopo login/registrazione: { path, state } o null. */
export function consumeBookingRedirect(loginResult, locationState) {
  const fromState = locationState?.afterLogin;
  const fromStorage = getBookingIntent();
  const pending = fromState || fromStorage;
  if (!pending?.path) return null;

  const roles = loginResult?.roles
    ?? (loginResult?.role ? [String(loginResult.role).replace(/^ROLE_/, '')] : []);
  const normalized = roles.map((r) => String(r).replace(/^ROLE_/, ''));
  const canBook = normalized.includes('PAZIENTE');

  if (!canBook) return null;

  clearBookingIntent();
  return { path: pending.path, state: pending.state || {} };
}
